<template>
  <div class="account-login">
    <div class="account-login-content">
      <div class="input-box">
        <span class="input-label"> {{ letter.accountLabel }}</span>
        <input
          name="account"
          v-model="account"
          class="input"
          :placeholder="letter.accountName"
          @focus="initViewport"
        />
      </div>
      <div class="input-box">
        <span class="input-label">{{ letter.passwordLabel }}</span>
        <input
          name="account"
          v-model="password"
          :placeholder="letter.password"
          class="input"
          type="password"
        />
      </div>
      <div class="bottom" v-if="showForgetPwd">
        <div class="forget-password" @click="jumpFindPwd">
          {{ letter.forgetPwd }}
        </div>
      </div>
      <div class="account-login-btn j-account-login-btn" @click="accountLogin">
        {{ letter.login }}
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { initViewport } from '@utiles/officialStore/index';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV3';
import {
  UPDATE_LOADING,
  SWITCH_SERVER,
  UPDATE_PC_SERVER_ID,
  UPDATE_ROLE_LIST,
  GET_SERVER_LIST
} from '@store/officialTopup/';
import { TOGGLE_REMEMBER, GO_ACCOUNT_LOGIN } from '@store/officialTopup/login';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();
export default {
  name: 'accountLogin',
  data() {
    return {
      account: '',
      password: '',
      loading: false,
      canAccountLogin: true
    };
  },
  methods: {
    checkInputValid() {
      if (!this.account.length) {
        alert(this.letter.accountName);
        return false;
      }
      if (!this.password.length) {
        alert(this.letter.password);
        return false;
      }
      return true;
    },
    accountLogin() {
      clickButton({
        btnName: 'account_login_confirm',
        locationKey: locationType.loginPopup
      });
      if (!this.checkInputValid()) {
        return;
      }
      if (!this.canAccountLogin) {
        return;
      }
      this.canAccountLogin = false;
      this.loading = true;
      this.$store.commit(UPDATE_LOADING, true);
      this.$store
        .dispatch(GO_ACCOUNT_LOGIN, {
          account: this.account,
          password: this.password
        })
        .then(res => {
          this.loading = false;
          this.canAccountLogin = true;
          this.$store.commit(UPDATE_LOADING, false);
          if (res?.result) {
            this.$store.commit(SWITCH_SERVER, 0);
            this.$store.commit(UPDATE_PC_SERVER_ID, 0);
            this.$store.commit(UPDATE_ROLE_LIST, []);
            this.$store.dispatch(GET_SERVER_LIST).then(_serverList => {
              this.$store.commit(UPDATE_LOADING, false);
            });
          } else {
            alert(res?.msg);
          }
        });
    },
    jumpFindPwd() {
      clickButton({
        btnName: 'find_password',
        locationKey: locationType.loginPopup
      });
      const link = `https://pay.${mainHost}/platform/passport.html?gameId=${this.gameId}&appLanguage=${this.$store.state.lang}&language=${this.$store.state.lang}#/findPwd`;
      sdkOpenLink({ link: getGlobalGetGotoLink({ link: link }) });
    },
    toggleRemember() {
      this.$store.commit(TOGGLE_REMEMBER);
    },
    initViewport
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      isRemember: state => state.login.isRemember,
      gameId: state => state.gameId
    }),
    showForgetPwd() {
      if (+this.gameId === 386) {
        return false;
      }
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialTopup/officialTopup.scss';
.account-login {
  box-sizing: border-box;
  padding: 0 40px;
  font-size: 22px;
  color: #333;
  &-content {
    width: 603px;
    @media screen and (orientation: landscape) {
      width: 100%;
    }
  }
  .input-box {
    height: 80px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-radius: 6px;
    border: solid 1px #e8e8e8;
    margin-bottom: 20px;

    .input-label {
      font-size: 20px;
      color: #999999;
      margin-right: 10px;
      flex-shrink: 0;
    }

    .login-icon {
      font-size: 30px;
      color: #555;
      margin-right: 16px;
    }
    .input {
      flex: 1;
      font-size: 24px;
    }
  }

  &-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px auto;
    line-height: 80px;
    height: 80px;
    font-size: 24px;
    color: #fff;
    background: $themeColor;
    border-radius: 6px;
    cursor: pointer;
  }
  .bottom {
    display: flex;
    justify-content: center;
  }
  .forget-password {
    cursor: pointer;
  }
}
</style>
